/**
 * Il composer inline ha un input di TESTO SEMPLICE, mentre le note della cronologia sono
 * salvate come HTML (è quello che produce l'editor TipTap del drawer e quello che le card
 * renderizzano). Qui si converte il testo digitato nello stesso markup minimo che TipTap
 * genererebbe per un paragrafo, con l'escaping delle entità: senza di esso un `<` digitato
 * dall'utente finirebbe interpretato come markup in lettura.
 *
 * Modulo PURO (nessun import) — testato a sé.
 */

const ESCAPES: Record<string, string> = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
};

export function escapeComposerHtml(text: string): string {
  return text.replace(/[&<>"']/g, (char) => ESCAPES[char] ?? char);
}

/**
 * Testo semplice → HTML della nota. Le righe vuote separano i paragrafi, le altre
 * interruzioni di riga diventano `<br>`; una stringa senza contenuto reale ritorna `''`
 * (il chiamante non deve mai salvare una nota vuota).
 */
export function plainTextToNoteHtml(text: string): string {
  const normalized = (text || '').replace(/\r\n?/g, '\n').trim();
  if (!normalized) return '';
  return normalized
    .split(/\n{2,}/)
    .map((paragraph) => `<p>${escapeComposerHtml(paragraph).replace(/\n/g, '<br>')}</p>`)
    .join('');
}
